<template>
    <div id="news_content">
        <div class="news-headline">{{ lbl.news_list.news_headline }}</div>
        <news-list v-if="isInitialModal"
            :lbl="lbl"
            :localeCode="localeCode"
            :initListConfig="listConfig"
            :controller="modalController">
        </news-list>

        <modal-master :controller="modalController" :theme="userType"></modal-master>
    </div>
</template>
<script>
import Vue from 'vue';
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//component
import NewsList from '../component/NewsList.vue';
//core
import {
    CampaignListConfigBuilder,
} from '@/core/Campaign/model/CampaignConfigModel.js';
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { AlertModalController } from "@/components/Modal/Controller/AlertModalController.js";
import { LoadingModalController } from "@/components/Modal/Controller/LoadingModalController.js";
//helper
import { TrackingService } from "@/helper/TrackingHelper.js";
export default {
    name: 'NewsListPage',
    components: {
        NewsList,
        ModalMaster
    },
    mixins: [
        AccountMixin,
        LocaleMixin
    ],
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    data: function () {
        return {
            isInitialModal: false,
            //config
            listConfig: {},
            filterConfig: {},

            //modal
            modalController: new ModalController(),
            alertModal: new AlertModalController(),
            loadingModal: new LoadingModalController(),

            trackingService: new TrackingService(this),
            trackingScreenName: 'newdetail',
            trackingEventCategory: 'newsdetail_page'
        };
    },
    created: function () {
        this.initialConfig();
        //modal
        this.modalController.setAlertModal(this.alertModal);
        this.modalController.setLoadingModal(this.loadingModal);

        console.log('news list page created');
        

        setTimeout(() => {
            this.isInitialModal = true;
        }, 200);
    },
    methods: {
        initialConfig: function () {
            this.listConfig = new CampaignListConfigBuilder()
                .setConfigList(Vue.bzbsConfig.mainConfig.news)
                .setTop(25)
                .create();
            
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";
#news_list {
    z-index: 100;
}
#news_content {
    padding: 0 20px 110px;
}

.news-headline {
    font-size: 1.75rem;
    font-family: $semi_bold;
    text-align: center;
    color: $green-00987F;
    line-height: normal;
    margin: 16px 0;

}
</style>
